// import "moment/locale/th";

import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  Row,
  Table,
  UncontrolledTooltip
} from "reactstrap";
import {
  DELETE_RP_BY_PASS_GAS,
  GET_AREA,
  GET_METER,
  GET_RP_BY_PASS_GAS,
  GET_RP_DEMAND_EXIT,
  GET_RP_SUPPLY_DEMAND,
  GET_RP_SUPPLY_DEMAND_ENTRY,
  GET_RP_SUPPLY_DEMAND_EXIT,
  GET_RP_SUPPLY_ENTRY,
  GET_ZONE,
  SAVE_LIST_RP_BY_PASS_GAS,
  SAVE_RP_BY_PASS_GAS,
  SAVE_RP_SUPPLY_DEMAND_ENTRY,
  SAVE_RP_SUPPLY_DEMAND_EXIT,
} from "helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { getPermission, getUserToken } from "../../../../helpers/auth_helper";

import $ from "jquery";
import BootstrapTable from "react-bootstrap-table-next";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import PropTypes from "prop-types";
import Tooltip from 'react-bootstrap/Tooltip';
import { groups } from "../../../../common/data/chat";
import img1 from '../../../../assets/images/small/Img_CalSimulation.jpg';
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SupplyDemand(props) {
  // console.log(props);
  const permission = getPermission();
  const dispatch = useDispatch();
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (typeof number == 'string') {
      // console.log(number)
      if (number.includes('+')) {

        return '+ ' + parseFloat(parseFloat(number.replaceAll(',', '').replaceAll('+', '').trim()).toFixed(digit)).toLocaleString(undefined, {
          minimumFractionDigits: digit,
        });
      }
      if (number.includes('-')) {
        return '- ' + parseFloat(parseFloat(number.replaceAll(',', '').replaceAll('-', '').trim()).toFixed(digit)).toLocaleString(undefined, {
          minimumFractionDigits: digit,
        });
      }
    }
    if (isFloat(number)) return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  function verSion2NumberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "" || number == undefined) return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  const ToNumberFormat = (cell, row, rowIndex) => numberFormat(cell, 2);
  const [columnsSummary, setColumnsSummary] = useState([
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "Supply-Demand",
      headerAlign: "center",
      align: "center",

      headerStyle: {
        backgroundColor: "#556ee678",
        color: "#46FCFF",
      },
      // sort: true,
    },
    {
      dataField: "SUPPLY_PLAN_ENTRY",
      text: "Planned Entry",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        // console.log(row)
        let className = "";
        if (row.ENTRY_groups != null)
          className = `SUPPLY_PLAN_ENTRY ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#667eef85",
        color: "#46FCFF",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "SUPPLY_ACTUAL_ENTRY",
      text: "Actual Entry",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.ENTRY_groups != null)
          className = `SUPPLY_ACTUAL_ENTRY ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#667eef85",
        color: "#46FCFF",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "SUPPLY_DIFF_ENTRY",
      text: "Diff Entry",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.ENTRY_groups != null)
          className = `SUPPLY_DIFF_ENTRY ${row.ENTRY_groups} rowspan${row.ENTRY_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#667eef85",
        color: "#46FCFF",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "DEMAND_PLAN_EXIT",
      text: "Planned Exit",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `DEMAND_PLAN_EXIT ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#5868b785",
        color: "#46FCFF",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "DEMAND_ACTUAL_EXIT",
      text: "Actual Exit",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `DEMAND_ACTUAL_EXIT ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#5868b785",
        color: "#46FCFF",
      },
      // sort: true,
      formatter: ToNumberFormat,
    },
    {
      dataField: "DEMAND_DIFF_EXIT",
      text: "Diff Exit",
      headerAlign: "center",
      align: "center",
      classes: (cell, row, rowIndex, colIndex) => {
        let className = "";
        // console.log(row)
        if (row.EXIT_groups != null)
          className = `DEMAND_DIFF_EXIT ${row.EXIT_groups} rowspan${row.EXIT_rowspan}`;
        return className;
      },
      headerStyle: {
        backgroundColor: "#5868b785",
        color: "#46FCFF",
      },
      formatter: ToNumberFormat,
      // sort: true,
    },
  ]);
  // const [searchDate, setSearchDate] = useState(moment(new Date().setDate(new Date().getDate() - 1)).format(
  //     "YYYY-MM-DD"));
  //   const searchDate = { SELECT_DATE: props.date };

  const columnColor = [
    "rgb(126 142 218)",
    "rgb(100 120 215)",
    "rgb(85 110 230)",
    "rgb(67 98 248)",
  ];

  const [modelDeviceListSummary, setModelDeviceListSummary] = useState([]);

  const [modelDeviceList, setModelDeviceList] = useState([]);
  const [meterEntryOption, setMeterEntryOption] = useState([]);
  const [meterExitOption, setMeterExitOption] = useState([]);
  const [zoneOption, setZoneOption] = useState([]);
  const [areaOption, setAreaOption] = useState([]);
  const [showManageEntryColumn, setShowManageEntryColumn] = useState(false);
  const [showManageExitColumn, setShowManageExitColumn] = useState(false);
  const [dataListMerge, setDataListMerge] = useState({
    entryDataList: [],
    exitDataList: [],
    dtEntry: [],
    dtExit: [],
  });
  const [byPassGas, setByPassGas] = useState({ BYPASSGAS_VOLUME: 0, BYPASS_UNIT: "MMscfd" });
  const [columnEntryManageList, setColumnEntryManageList] = useState([]);
  const [columnExitManageList, setColumnExitManageList] = useState([]);
  const [showExitColumn, setShowExitColumn] = useState({
    // flag: 1,
    first: true,
    second: true,
    third: true,
  });

  const [showDialogFormula, setShowDialogFormula] = useState(false);
  const [dataList, setDataList] = useState([]);

  //sort Column//
  const defaultSorted = [
    {
      dataField: "PID",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "250",
        value: 250,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = "white";

    return style;
  };

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  const rowStyleSummary = (row, rowIndex) => {
    const style = {};
    if (rowIndex == modelDeviceList.length - 1) {
      style.backgroundColor = "#556ee64a";
      style.color = "#FFFFFF";
    } else {
      style.color = "#FFFFFF";
    }
    style.verticalAlign = 'middle'

    return style;
  };

  //headerColumn
  useEffect(() => {
    let classMerged = [];
    function mergeCell(index) {
      if (classMerged.indexOf($(this).attr("class")) == -1) {
        let [field, group, rowspan] = $(this).attr("class")?.split(/\s+/);
        $(this).attr("rowspan", rowspan.replaceAll("rowspan", ""));
        $(`.${field}.${group}.${rowspan}`).not(":first").hide();
      }
      classMerged.push($(this).attr("class"));
    }
    $(".SUPPLY_PLAN_ENTRY").each(mergeCell);
    $(".SUPPLY_ACTUAL_ENTRY").each(mergeCell);
    $(".SUPPLY_DIFF_ENTRY").each(mergeCell);
    $(".DEMAND_PLAN_EXIT").each(mergeCell);
    $(".DEMAND_ACTUAL_EXIT").each(mergeCell);
    $(".DEMAND_DIFF_EXIT").each(mergeCell);
  }, [modelDeviceList]);

  //headerColumn

  const columnOption = {
    menu: (provided, state) => ({
      ...provided,
      width: 270,
    }),
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "#2E3446" : undefined,
      };
    },
    multiValue: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: "#2A3042",
      };
    },
    multiValueLabel: (styles, { data }) => ({
      ...styles,
      color: "#FFFFFF",
    }),
    multiValueRemove: (styles, { data }) => ({
      ...styles,
      color: "#BFC8E2",
      ":hover": {
        backgroundColor: "#2A3042",
        color: "white",
      },
    }),
  };
  const SelectEntryMeter = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnEntryManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meter: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterEntryOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitSetRatioMeter1 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitSetRatio1: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitSetRatioMeter2 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitSetRatio2: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const SelectExitSetRatioMeter3 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitSetRatio3: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const SelectExitDivisorMeter1 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitDivisor1: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const SelectExitDivisorMeter2 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitDivisor2: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitDivisorMeter3 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitDivisor3: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const SelectEntryZone = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnEntryManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    zone: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={zoneOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const headerToolTip = (idToolTip, columnsName, showToolTip) => {

    return (
      <div>
        <span> {columnsName} </span>
        <i className="fas fa-info-circle mt-1 mb-1 ms-1" id={idToolTip} style={{ cursor: "pointer", fontSize: "20px", color: "#9CB2FF" }}>
          <UncontrolledTooltip
            placement="left-start"
            target={idToolTip}
            style={{ maxWidth: "1000px" }}
          >
            <span style={{ fontSize: "15px" }}>
              {showToolTip}
            </span>
          </UncontrolledTooltip>
        </i>
      </div>
    )

  }

  const SelectExitOverhead1 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    overhead1: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={areaOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const SelectExitOverhead2 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    overhead2: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={areaOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };
  const SelectExitOverhead3 = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    overhead3: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={areaOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitSetWeightedMeter1 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitWeightedSet1: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitSetWeightedMeter2 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitWeightedSet2: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitSetWeightedMeter3 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitWeightedSet3: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitWeightedDivisor1 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitWeightedDivisor1: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitWeightedDivisor2 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitWeightedDivisor2: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitWeightedDivisor3 = (cellContent, row) => {
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    meterExitWeightedDivisor3: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={meterExitOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const SelectExitZone = (cellContent, row) => {
    // console.log(row)
    return (
      <div>
        <Select
          value={cellContent}
          isClearable={false}
          isMulti
          onChange={selected => {
            setColumnExitManageList(prev => {
              return prev.map(obj => {
                if (row.ROW == obj.ROW) {
                  return {
                    ...obj,
                    zone: selected,
                  };
                }
                return { ...obj };
              });
            });
          }}
          options={zoneOption}
          classNamePrefix="select2-selection"
          styles={columnOption}
        />
      </div>
    );
  };

  const tester = (cellContent, row) => {
    // console.log(row)
    return (
      <div>

      </div>
    );
  };

  const columnEntryManage = [
    {
      dataField: "SUPPLYDEMAND_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "100px",
      },
      type: "number",
    },
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "Column Name",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "zone",
      text: "Zone ( Entry )",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",

      style: {
        width: "300px",
      },
      formatter: SelectEntryZone,
    },
    {
      dataField: "meter",
      text: "Meter ( Entry )",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",

      style: {
        width: "300px",
      },
      formatter: SelectEntryMeter,
    },
    // {
    //   dataField: "SUPPLYDEMAND_DESC",
    //   text: "Description",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "150px",
    //   },
    // },
    // {
    //   dataField: "SUPPLYDEMAND_TYPE",
    //   text: "Group",
    //   headerAlign: "center",
    //   sort: true,
    //   editable: true,
    //   align: "center",
    //   style: {
    //     width: "70px",
    //   },
    // },
    {
      dataField: "SUPPLYDEMAND_SHOW",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      style: {
        width: "100px",
      },
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: true,
            label: "Show",
          },
          {
            value: false,
            label: "Hide",
          },
        ],
      },
      formatter: (cell, row, rowIndex) =>
        row.SUPPLYDEMAND_SHOW == true || row.SUPPLYDEMAND_SHOW == "true"
          ? "Show"
          : "Hide",
    },
  ];

  useEffect(() => {
    setColumnExitManage([{
      dataField: "SUPPLYDEMAND_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      headerStyle: { fontSize: "12px", width: "150px", },
      style: {
        width: "150px",
        fontSize: "12px",
      },
      type: "number",
    },
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "Column",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      headerStyle: { fontSize: "12px", width: "150px" },
      style: {
        width: "150px",
        fontSize: "12px",
      },
    },
    {
      dataField: "zone",
      text: "Zone",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: { fontSize: "12px", width: "200px" },
      style: {
        width: "200px",
        fontSize: "12px",
      },
      formatter: SelectExitZone,
    },
    {
      dataField: "overhead1",
      text: "Overhead 1st",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("Overhead1st", "Overhead 1st", "Area"),
      headerStyle: { fontSize: "12px", width: "250px", borderLeft: "solid 10px #32394e" },
      style: {
        width: "250px",
        fontSize: "12px",
        borderLeft: "solid 10px #32394e",
      },
      formatter: SelectExitOverhead1,
      hidden: !showExitColumn.first,
    },
    {
      dataField: "meterExitSetRatio1",
      text: "Ratio Set 1st",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("RatioSet1st", "Ratio Set 1st", "Meter"),
      headerStyle: { fontSize: "12px", width: "250px" },
      style: {
        width: "250px",
        fontSize: "12px",
      },
      formatter: SelectExitSetRatioMeter1,
      hidden: !showExitColumn.first,
    },
    {
      dataField: "meterExitDivisor1",
      text: "Ratio Divisor 1st",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("RatioDivisor1st", "Ratio Divisor 1st", "Meter"),
      headerStyle: { fontSize: "12px", width: "250px" },
      style: {
        width: "250px",
        fontSize: "12px",
      },
      formatter: SelectExitDivisorMeter1,
      hidden: !showExitColumn.first,
    },
    {
      dataField: "meterExitWeightedSet1",
      text: "Weighted Set 1st",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("WeightedSet1st", "Weighted Set 1st", "Meter"),
      headerStyle: { fontSize: "12px", width: "300px" },
      style: {
        width: "300px",
        fontSize: "12px",
      },
      formatter: SelectExitSetWeightedMeter1,
      hidden: !showExitColumn.first,
    },
    {
      dataField: "meterExitWeightedDivisor1",
      text: "Weighted Divisor 1st",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("WeightedDivisor1st", "Weighted Divisor 1st", "Meter"),
      headerStyle: { fontSize: "12px", width: "350px" },
      style: {
        width: "350px",
        fontSize: "12px",
      },
      formatter: SelectExitWeightedDivisor1,
      hidden: !showExitColumn.first,
    },
    {
      dataField: "overhead2",
      text: "Overhead 2nd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("Overhead2nd", "Overhead 2nd", "Area"),
      headerStyle: { fontSize: "12px", width: "250px", borderLeft: "solid 10px #32394e" },
      style: {
        width: "250px",
        fontSize: "12px",
        borderLeft: "solid 10px #32394e "
      },
      formatter: SelectExitOverhead2,
      hidden: !showExitColumn.second,
    },
    {
      dataField: "meterExitSetRatio2",
      text: "Ratio Set 2nd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("RatioSet2nd", "Ratio Set 2nd", "Meter"),
      headerStyle: { fontSize: "12px", width: "250px" },
      style: {
        width: "250px",
        fontSize: "12px",
      },
      formatter: SelectExitSetRatioMeter2,
      hidden: !showExitColumn.second,
    },
    {
      dataField: "meterExitDivisor2",
      text: "Ratio Divisor 2nd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("RatioDivisor2nd", "Ratio Divisor 2nd", "Meter"),
      headerStyle: { fontSize: "12px", width: "300px" },
      style: {
        width: "300px",
        fontSize: "10px",
      },
      formatter: SelectExitDivisorMeter2,
      hidden: !showExitColumn.second,
    },
    {
      dataField: "meterExitWeightedSet2",
      text: "Weighted Set 2nd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("WeightedSet2nd", "Weighted Set 2nd", "Meter"),
      headerStyle: { fontSize: "12px", width: "300px" },
      style: {
        width: "300px",
        fontSize: "12px",
      },
      formatter: SelectExitSetWeightedMeter2,
      hidden: !showExitColumn.second,
    },
    {
      dataField: "meterExitWeightedDivisor2",
      text: "Weighted Divisor 2nd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("WeightedDivisor2nd", "Weighted Divisor 2nd", "Meter"),
      headerStyle: { fontSize: "12px", width: "350px" },
      style: {
        width: "350px",
        fontSize: "12px",
      },
      formatter: SelectExitWeightedDivisor2,
      hidden: !showExitColumn.second,
    },
    {
      dataField: "overhead3",
      text: "Overhead 3rd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("Overhead3rd", "Overhead 3rd", "Area"),
      headerStyle: { fontSize: "12px", width: "250px", borderLeft: "solid 10px #32394e" },
      style: {
        width: "250px",
        fontSize: "12px",
        borderLeft: "solid 10px #32394e",
      },
      formatter: SelectExitOverhead3,
      hidden: !showExitColumn.third,
    },
    {
      dataField: "meterExitSetRatio3",
      text: "Ratio Set 3rd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("RatioSet3rd", "Ratio Set 3rd", "Meter"),
      headerStyle: { fontSize: "12px", width: "250px" },
      style: {
        width: "250px",
        fontSize: "12px",
      },
      formatter: SelectExitSetRatioMeter3,
      hidden: !showExitColumn.third,
    },
    {
      dataField: "meterExitDivisor3",
      text: "Ratio Divisor 3rd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("RatioDivisor3rd", "Ratio Divisor 3rd", "Meter"),
      headerStyle: { fontSize: "12px", width: "300px" },
      style: {
        width: "300px",
        fontSize: "12px",
      },
      formatter: SelectExitDivisorMeter3,
      hidden: !showExitColumn.third,
    },
    {
      dataField: "meterExitWeightedSet3",
      text: "Weighted Set 3rd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("WeightedSet3rd", "Weighted Set 3rd", "Meter"),
      headerStyle: { fontSize: "12px", width: "300px" },
      style: {
        width: "300px",
        fontSize: "12px",
      },
      formatter: SelectExitSetWeightedMeter3,
      hidden: !showExitColumn.third,
    },
    {
      dataField: "meterExitWeightedDivisor3",
      text: "Weighted Divisor 3rd",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerFormatter: (column, colIndex) => headerToolTip("WeightedDivisor3rd", "Weighted Divisor 3rd", "Meter"),
      headerStyle: { fontSize: "12px", width: "350px" },
      style: {
        width: "350px",
        fontSize: "12px",
      },
      formatter: SelectExitWeightedDivisor3,
      hidden: !showExitColumn.third,
    },

    {
      dataField: "SUPPLYDEMAND_SHOW",
      text: "Status",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      headerStyle: { fontSize: "12px", width: "150px", borderLeft: "solid 10px #32394e" },
      style: {
        width: "150px",
        fontSize: "12px",
        borderLeft: "solid 10px #32394e"
      },
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: true,
            label: "Show",
          },
          {
            value: false,
            label: "Hide",
          },
        ],
      },
      formatter: (cell, row, rowIndex) =>
        row.SUPPLYDEMAND_SHOW == true || row.SUPPLYDEMAND_SHOW == "true"
          ? "Show"
          : "Hide",
    }])
  }, [showExitColumn]);

  const [columnExitManage, setColumnExitManage] = useState([
    {
      dataField: "SUPPLYDEMAND_ORDER",
      text: "Order",
      headerAlign: "center",
      sort: true,
      editable: true,
      align: "center",
      headerStyle: { fontSize: "10px" },
      style: {
        width: "50px",
        fontSize: "10px",
      },
      type: "number",
    },
    {
      dataField: "SUPPLYDEMAND_NAME",
      text: "Column",
      headerAlign: "center",
      sort: true,
      editable: (content, row, rowIndex, columnIndex) => row.PID == "",
      align: "center",
      headerStyle: { fontSize: "10px" },
      style: {
        width: "70px",
        fontSize: "10px",
      },
    },
    {
      dataField: "zone",
      text: "Zone",
      headerAlign: "center",
      sort: false,
      editable: false,
      align: "center",
      headerStyle: { fontSize: "10px" },
      style: {
        width: "100px",
        fontSize: "10px",
      },
      formatter: SelectExitZone,
    },

  ]);

  const getColumnEntry = () => post(GET_RP_SUPPLY_DEMAND_ENTRY, {});
  const getColumnExit = () => post(GET_RP_SUPPLY_DEMAND_EXIT, {});
  const handleAddEntryColumn = () => {
    setColumnEntryManageList(prevent => [
      ...prevent,
      {
        ROW: columnEntryManageList.length + 1,
        PID: "",
        SUPPLYDEMAND_ORDER: columnEntryManageList.length + 1,
        SUPPLYDEMAND_NAME: "",
        SUPPLYDEMAND_ZONE: "",
        SUPPLYDEMAND_SET: "",
        SUPPLYDEMAND_DIVISOR: "",
        SUPPLYDEMAND_DESC: "",
        SUPPLYDEMAND_TYPE: 0,
        SUPPLYDEMAND_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        zone: [],
        meter: [],
      },
    ]);
  };
  const handleAddExitColumn = () => {
    setColumnExitManageList(prevent => [
      ...prevent,
      {
        ROW: columnExitManageList.length + 1,
        PID: "",
        SUPPLYDEMAND_ORDER: columnExitManageList.length + 1,
        SUPPLYDEMAND_NAME: "",
        SUPPLYDEMAND_ZONE: "",
        SUPPLYDEMAND_SET1: "",
        SUPPLYDEMAND_SET2: "",
        SUPPLYDEMAND_SET3: "",
        SUPPLYDEMAND_DIVISOR1: "",
        SUPPLYDEMAND_DIVISOR2: "",
        SUPPLYDEMAND_DIVISOR3: "",
        SUPPLYDEMAND_WEIGHT_SET1: "",
        SUPPLYDEMAND_WEIGHT_SET2: "",
        SUPPLYDEMAND_WEIGHT_SET3: "",
        SUPPLYDEMAND_WEIGHT_DIV1: "",
        SUPPLYDEMAND_WEIGHT_DIV2: "",
        SUPPLYDEMAND_WEIGHT_DIV3: "",
        SUPPLYDEMAND_DESC: "",
        SUPPLYDEMAND_TYPE: 0,
        SUPPLYDEMAND_SHOW: true,
        PRIORITY_FLAG: 0,
        STATUS_FLAG: 0,
        zone: [],
        overhead1: [],
        overhead2: [],
        overhead3: [],
        meterExitSetRatio1: [],
        meterExitSetRatio2: [],
        meterExitSetRatio3: [],
        meterExitDivisor1: [],
        meterExitDivisor2: [],
        meterExitDivisor3: [],
        meterExitWeightedSet1: [],
        meterExitWeightedSet2: [],
        meterExitWeightedSet3: [],
        meterExitWeightedDivisor1: [],
        meterExitWeightedDivisor2: [],
        meterExitWeightedDivisor3: [],
      },
    ]);
  };
  const handleSaveEntryColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnEntryManageList.map(function (item) {
        return item.SUPPLYDEMAND_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnEntryManageList.some(
          row => row.SUPPLYDEMAND_NAME == "" || row.SUPPLYDEMAND_ORDER == ""
        )
      ) {
        let data = [...columnEntryManageList];
        let res = [];

        await Promise.all(
          data.map(async row => {
            let response = await post(SAVE_RP_SUPPLY_DEMAND_ENTRY, {
              ...row,
              SUPPLYDEMAND_ZONE: row.zone.map(zone => zone.label).toString(),
              SUPPLYDEMAND_DESC: row.meter.map(meter => meter.label).toString(),
            });
            res.push(response);
          })
        );

        // let res = await post(SAVE_RP_SUPPLY_DEMAND_ENTRY, data);
        if (res.every(row => row.resultCode == 200)) {
          fetchData();
          setShowManageEntryColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        } else {
          dispatch(
            messageAction.showMessage(
              res.find(row => row.resultCode != 200).resultDescription
            )
          );
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const handleSaveExitColumn = async () => {
    function validateDuplicate() {
      let valueArr = columnExitManageList.map(function (item) {
        return item.SUPPLYDEMAND_NAME;
      });
      let isDuplicate = valueArr.some(function (item, idx) {
        return valueArr.indexOf(item) != idx;
      });
      return isDuplicate;
    }
    if (validateDuplicate()) {
      dispatch(messageAction.showMessage("Column name is duplicate."));
      throw "exit";
    }
    dispatch(loadingAction.showLoading());
    try {
      if (
        !columnExitManageList.some(
          row => row.SUPPLYDEMAND_NAME == "" || row.SUPPLYDEMAND_ORDER == ""
        )
      ) {
        let data = [...columnExitManageList];
        let res = [];

        await Promise.all(
          data.map(async row => {
            let response = await post(SAVE_RP_SUPPLY_DEMAND_EXIT, {
              ...row,
              SUPPLYDEMAND_ZONE: row.zone.map(zone => zone.label).toString(),
              SUPPLYDEMAND_OVERHEAD1: row.overhead1
                .map(overhead => overhead.label)
                .toString(),
              SUPPLYDEMAND_OVERHEAD2: row.overhead2
                .map(overhead => overhead.label)
                .toString(),
              SUPPLYDEMAND_OVERHEAD3: row.overhead3
                .map(overhead => overhead.label)
                .toString(),
              SUPPLYDEMAND_SET1: row.meterExitSetRatio1
                .map(meterExitSetRatio => meterExitSetRatio.label)
                .toString(),
              SUPPLYDEMAND_SET2: row.meterExitSetRatio2
                .map(meterExitSetRatio => meterExitSetRatio.label)
                .toString(),
              SUPPLYDEMAND_SET3: row.meterExitSetRatio3
                .map(meterExitSetRatio => meterExitSetRatio.label)
                .toString(),
              SUPPLYDEMAND_DIVISOR1: row.meterExitDivisor1
                .map(meterExitDivisor => meterExitDivisor.label)
                .toString(),
              SUPPLYDEMAND_DIVISOR2: row.meterExitDivisor2
                .map(meterExitDivisor => meterExitDivisor.label)
                .toString(),
              SUPPLYDEMAND_DIVISOR3: row.meterExitDivisor3
                .map(meterExitDivisor => meterExitDivisor.label)
                .toString(),
              SUPPLYDEMAND_WEIGHT_SET1: row.meterExitWeightedSet1
                .map(meterExitWeightedSet => meterExitWeightedSet.label)
                .toString(),
              SUPPLYDEMAND_WEIGHT_SET2: row.meterExitWeightedSet2
                .map(meterExitWeightedSet => meterExitWeightedSet.label)
                .toString(),
              SUPPLYDEMAND_WEIGHT_SET3: row.meterExitWeightedSet3
                .map(meterExitWeightedSet => meterExitWeightedSet.label)
                .toString(),
              SUPPLYDEMAND_WEIGHT_DIV1: row.meterExitWeightedDivisor1
                .map(meterExitWeightedDivisor => meterExitWeightedDivisor.label)
                .toString(),
              SUPPLYDEMAND_WEIGHT_DIV2: row.meterExitWeightedDivisor2
                .map(meterExitWeightedDivisor => meterExitWeightedDivisor.label)
                .toString(),
              SUPPLYDEMAND_WEIGHT_DIV3: row.meterExitWeightedDivisor3
                .map(meterExitWeightedDivisor => meterExitWeightedDivisor.label)
                .toString(),
            });

            res.push(response);
          })
        );

        // let res = await post(SAVE_RP_SUPPLY_DEMAND_ENTRY, data);
        if (res.every(row => row.resultCode == 200)) {
          fetchData();
          setShowManageExitColumn(false);
          dispatch(messageAction.showMessage("Save success."));
        } else {
          dispatch(
            messageAction.showMessage(
              res.find(row => row.resultCode != 200).resultDescription
            )
          );
        }
      } else {
        dispatch(messageAction.showMessage("Plesae key in."));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const generateRow = () => {

    let entryList = [
      ...dataListMerge.entryDataList.filter(
        row => row.SUPPLYDEMAND_SHOW == true
      ),
    ];
    let exitList = [
      ...dataListMerge.exitDataList.filter(
        row => row.SUPPLYDEMAND_SHOW == true
      ),
    ];
    let rowData = [];
    entryList.map(row => {
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`ENTRY_${key}`] = value;
      }

      let prevData = rowData.find(
        prev => prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME
      );
      if (prevData) {
        rowData = rowData.map(prev => {
          if (prev.SUPPLYDEMAND_NAME == obj.ENTRY_SUPPLYDEMAND_NAME) {
            return { ...prev, ...obj };
          }
          return prev;
        });
      } else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME;
        rowData.push(obj);
      }
    });
    exitList.map(row => {
      let obj = {};
      for (const [key, value] of Object.entries(row)) {
        obj[`EXIT_${key}`] = value;
      }

      let prevData = rowData.find(
        prev => prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME
      );

      if (prevData) {
        rowData = rowData.map(prev => {

          if (prev.SUPPLYDEMAND_NAME == obj.EXIT_SUPPLYDEMAND_NAME) {

            return { ...prev, ...obj };
          }
          return prev;
        });

      }
      else {
        obj.SUPPLYDEMAND_NAME = row.SUPPLYDEMAND_NAME;
        rowData.push(obj);
      }
    });
    rowData = rowData.map((row, index) => ({ ...row, row: index }));
    // console.log(rowData)
    let tempRowData = addFieldToModelDeviceList(rowData);
    // console.log(tempRowData)
    if (tempRowData) setModelDeviceList([...tempRowData]);
  };

  const handleShowManageEntryColumn = async () => {
    setColumnEntryManageList([]);
    dispatch(loadingAction.showLoading());
    try {
      setShowManageEntryColumn(true);
      let column = await getColumnEntry();

      setColumnEntryManageList(
        column.data.rpSupplyDemandEntryList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          zone: obj.SUPPLYDEMAND_ZONE
            ? zoneOption.filter(
              opt => obj.SUPPLYDEMAND_ZONE.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meter: obj.SUPPLYDEMAND_DESC
            ? meterEntryOption.filter(
              opt => obj.SUPPLYDEMAND_DESC.split(",").indexOf(opt.label) >= 0
            )
            : [],
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const handleShowManageExitColumn = async () => {
    setColumnExitManageList([]);
    setShowExitColumn({
      // flag: 1,
      first: true,
      second: true,
      third: true,
    });
    dispatch(loadingAction.showLoading());
    try {
      setShowManageExitColumn(true);
      let column = await getColumnExit();
      // console.log(column);
      setColumnExitManageList(
        column.data.rpSupplyDemandExitList.map((obj, index) => ({
          ...obj,
          ROW: index + 1,
          zone: obj.SUPPLYDEMAND_ZONE
            ? zoneOption.filter(
              opt => obj.SUPPLYDEMAND_ZONE.split(",").indexOf(opt.label) >= 0
            )
            : [],
          overhead1: obj.SUPPLYDEMAND_OVERHEAD1
            ? areaOption.filter(
              opt =>
                obj.SUPPLYDEMAND_OVERHEAD1.split(",").indexOf(opt.label) >= 0
            )
            : [],
          overhead2: obj.SUPPLYDEMAND_OVERHEAD2
            ? areaOption.filter(
              opt =>
                obj.SUPPLYDEMAND_OVERHEAD2.split(",").indexOf(opt.label) >= 0
            )
            : [],
          overhead3: obj.SUPPLYDEMAND_OVERHEAD3
            ? areaOption.filter(
              opt =>
                obj.SUPPLYDEMAND_OVERHEAD3.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitSetRatio1: obj.SUPPLYDEMAND_SET1
            ? meterExitOption.filter(
              opt => obj.SUPPLYDEMAND_SET1.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitSetRatio2: obj.SUPPLYDEMAND_SET2
            ? meterExitOption.filter(
              opt => obj.SUPPLYDEMAND_SET2.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitSetRatio3: obj.SUPPLYDEMAND_SET3
            ? meterExitOption.filter(
              opt => obj.SUPPLYDEMAND_SET3.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitDivisor1: obj.SUPPLYDEMAND_DIVISOR1
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_DIVISOR1.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitDivisor2: obj.SUPPLYDEMAND_DIVISOR2
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_DIVISOR2.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitDivisor3: obj.SUPPLYDEMAND_DIVISOR3
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_DIVISOR3.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitWeightedSet1: obj.SUPPLYDEMAND_WEIGHT_SET1
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_WEIGHT_SET1.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitWeightedSet2: obj.SUPPLYDEMAND_WEIGHT_SET2
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_WEIGHT_SET2.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitWeightedSet3: obj.SUPPLYDEMAND_WEIGHT_SET3
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_WEIGHT_SET3.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitWeightedDivisor1: obj.SUPPLYDEMAND_WEIGHT_DIV1
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_WEIGHT_DIV1.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitWeightedDivisor2: obj.SUPPLYDEMAND_WEIGHT_DIV2
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_WEIGHT_DIV2.split(",").indexOf(opt.label) >= 0
            )
            : [],
          meterExitWeightedDivisor3: obj.SUPPLYDEMAND_WEIGHT_DIV3
            ? meterExitOption.filter(
              opt =>
                obj.SUPPLYDEMAND_WEIGHT_DIV3.split(",").indexOf(opt.label) >= 0
            )
            : [],
        }))
      );
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  const fetchData = async () => {
    function compare(a, b) {
      if (a.SUPPLYDEMAND_ORDER < b.SUPPLYDEMAND_ORDER) {
        return -1;
      }
      if (a.SUPPLYDEMAND_ORDER > b.SUPPLYDEMAND_ORDER) {
        return 1;
      }
      return 0;
    }

    dispatch(loadingAction.showLoading());
    try {
      let [entry, exit, dtEntry, dtExit, byPassGas] = await Promise.all([
        getColumnEntry(),
        getColumnExit(),
        post(GET_RP_SUPPLY_ENTRY, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" }),
        post(GET_RP_DEMAND_EXIT, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" }),
        post(GET_RP_BY_PASS_GAS, { SUMMARYREPORT_PID: props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682" })
      ]);

      // console.log(entry,exit);
      if (byPassGas.data.rpBypassGasList.length == 1) {
        setByPassGas(byPassGas.data.rpBypassGasList[0]);
      }

      setDataListMerge({
        entryDataList: entry.data.rpSupplyDemandEntryList
          .sort(compare)
          .filter(obj => obj.SUPPLYDEMAND_SHOW == true)
          .map((obj, index) => ({
            ...obj,
            ROW: index + 1,
          })),
        exitDataList: exit.data.rpSupplyDemandExitList
          .sort(compare)
          .filter(obj => obj.SUPPLYDEMAND_SHOW == true)
          .map((obj, index) => ({
            ...obj,
            ROW: index + 1,
          })),

        dtEntry: dtEntry.data.rpSupplyEntryList,
        dtExit: dtExit.data.RPDemandExitList,
      });

    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };
  const getOption = async () => {
    try {
      let [meter, zone, area] = await Promise.all([
        post(GET_METER, {}),
        post(GET_ZONE, {}),
        post(GET_AREA, {})
      ]);
      // console.log(meter,zone)
      setMeterEntryOption(
        meter.data.MeterList.filter(item => item.POINT_NAME == "Entry")
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );

      setMeterExitOption(
        meter.data.MeterList.filter(
          item => item.POINT_NAME == "Exit" || item.POINT_NAME == "Balance"
        )
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );

      setZoneOption(
        zone.data.zoneList
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      );
      setAreaOption(
        area.data.areaList
          .map(obj => ({ label: obj.ALIAS_NAME, value: obj.PID }))
          .sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      )
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
  };

  useEffect(() => {
    // generateRow();
  }, [dataList]);

  useEffect(() => {
    // console.log(meterExitOption);
  }, [meterExitOption]);

  useEffect(() => {
    // console.log(meterEntryOption);
  }, [meterEntryOption]);

  useEffect(() => {
    getOption();
    fetchData();
  }, []);
  useEffect(() => {
    fetchData();
  }, [props.summaryReportPid]);

  useEffect(() => {
    if (
      dataListMerge.entryDataList.length > 0 ||
      dataListMerge.exitDataList.length > 0
    ) {
      // console.log(3)
      generateRow();
    }
  }, [dataListMerge]);
  const defaultEntrySortColumnManage = [
    {
      dataField: "SUPPLYDEMAND_ORDER",
      order: "asc", // or desc
    },
  ];
  const defaultExitSortColumnManage = [
    {
      dataField: "SUPPLYDEMAND_ORDER",
      order: "asc", // or desc
    },
  ];
  const addFieldToModelDeviceList = rowList => {
    // console.log(dataListMerge.dtEntry)
    let dataModel = {
      PID: "",
      SUPPLYDEMAND_PID: "",
      SUPPLYDEMAND_ORDER: 0,
      SUPPLYDEMAND_NAME: "",
      SUPPLY_PLAN_ENTRY: "",
      SUPPLY_ACTUAL_ENTRY: "",
      SUPPLY_DIFF_ENTRY: "",
      DEMAND_PLAN_EXIT: "",
      DEMAND_ACTUAL_EXIT: "",
      DEMAND_DIFF_EXIT: "",
      PRIORITY_FLAG: 0,
      STATUS_FLAG: 0,
    };
    if (rowList.length > 0) {
      // console.log(dataList)
      let mergeEntryCell = [];
      let mergeExitCell = [];
      let notInList = [];
      dataListMerge.entryDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.entryDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {
            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_DESC == e.SUPPLYDEMAND_DESC &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE
            ) {
              let preventData = mergeEntryCell.find(
                obj => obj.ENTRY_group == index
              );
              notInList.push(e.PID);
              if (preventData) {
                mergeEntryCell = [
                  ...mergeEntryCell.map(prev => {
                    if (prev.ENTRY_group == index) {
                      prev.ENTRY_subPid = [...prev.ENTRY_subPid, e.PID];
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeEntryCell.push({
                  ENTRY_group: index,
                  ENTRY_mainPid: row.PID,
                  ENTRY_subPid: [e.PID],
                });
              }
            }
          });
      });

      dataListMerge.exitDataList.map((row, index) => {
        notInList.push(row.PID);
        dataListMerge.exitDataList
          .filter(x => notInList.indexOf(x.PID) == -1)
          .map(e => {
            if (
              row.PID != e.PID &&
              row.SUPPLYDEMAND_ZONE == e.SUPPLYDEMAND_ZONE &&
              row.SUPPLYDEMAND_SET1 == e.SUPPLYDEMAND_SET1 &&
              row.SUPPLYDEMAND_OVERHEAD1 == e.SUPPLYDEMAND_OVERHEAD1 &&
              row.SUPPLYDEMAND_DIVISOR1 == e.SUPPLYDEMAND_DIVISOR1 &&
              row.SUPPLYDEMAND_WEIGHT_SET1 == e.SUPPLYDEMAND_WEIGHT_SET1 &&
              row.SUPPLYDEMAND_WEIGHT_DIV1 == e.SUPPLYDEMAND_WEIGHT_DIV1 &&
              row.SUPPLYDEMAND_SET2 == e.SUPPLYDEMAND_SET2 &&
              row.SUPPLYDEMAND_OVERHEAD2 == e.SUPPLYDEMAND_OVERHEAD2 &&
              row.SUPPLYDEMAND_DIVISOR2 == e.SUPPLYDEMAND_DIVISOR2 &&
              row.SUPPLYDEMAND_WEIGHT_SET2 == e.SUPPLYDEMAND_WEIGHT_SET2 &&
              row.SUPPLYDEMAND_WEIGHT_DIV2 == e.SUPPLYDEMAND_WEIGHT_DIV2 &&
              row.SUPPLYDEMAND_SET3 == e.SUPPLYDEMAND_SET3 &&
              row.SUPPLYDEMAND_OVERHEAD3 == e.SUPPLYDEMAND_OVERHEAD3 &&
              row.SUPPLYDEMAND_DIVISOR3 == e.SUPPLYDEMAND_DIVISOR3 &&
              row.SUPPLYDEMAND_WEIGHT_SET3 == e.SUPPLYDEMAND_WEIGHT_SET3 &&
              row.SUPPLYDEMAND_WEIGHT_DIV3 == e.SUPPLYDEMAND_WEIGHT_DIV3
            ) {
              // console.log(2);
              let preventData = mergeExitCell.find(
                obj => obj.EXIT_group == index
              );
              notInList.push(e.PID);
              if (preventData) {
                mergeExitCell = [
                  ...mergeExitCell.map(prev => {
                    if (prev.EXIT_group == index) {
                      prev.EXIT_subPid = [...prev.EXIT_subPid, e.PID];
                      prev.DEMAND_PLAN_EXIT_REDUCE =
                        prev.DEMAND_PLAN_EXIT_REDUCE + e.DEMAND_PLAN_EXIT;
                      prev.DEMAND_ACTUAL_EXIT_REDUCE =
                        prev.DEMAND_ACTUAL_EXIT_REDUCE + e.DEMAND_ACTUAL_EXIT;
                    }
                    return prev;
                  }),
                ];
              } else {
                mergeExitCell.push({
                  EXIT_group: index,
                  EXIT_mainPid: row.PID,
                  EXIT_subPid: [e.PID],
                  DEMAND_PLAN_EXIT_REDUCE: row.DEMAND_PLAN_EXIT,
                  DEMAND_ACTUAL_EXIT_REDUCE: row.DEMAND_ACTUAL_EXIT,
                });
              }
            }
          });
      });
      // console.log(mergeExitCell);
      let modelList = [];

      rowList.map(objRow => {
        // console.log(objRow,dataListMerge.dtEntry)
        let dataEntry = dataListMerge.dtEntry.find(
          row => row.SUPPLYENTRY_PID == objRow.ENTRY_PID
        );
        let dataExit = dataListMerge.dtExit.find(
          row => row.DEMANDEXIT_PID == objRow.EXIT_PID
        );
        // console.log(dataEntry)
        let mergeEntry = mergeEntryCell.find(
          row =>
            objRow.ENTRY_PID == row.ENTRY_mainPid ||
            row.ENTRY_subPid.indexOf(objRow.ENTRY_PID) >= 0
        );
        let mergeExit = mergeExitCell.find(
          row =>
            objRow.EXIT_PID == row.EXIT_mainPid ||
            row.EXIT_subPid.indexOf(objRow.EXIT_PID) >= 0
        );
        // console.log(mergeExit);
        modelList.push({
          ...dataModel,
          ...objRow,
          ...dataEntry,
          ...dataExit,
          ENTRY_groups: mergeEntry ? mergeEntry.ENTRY_group : null,
          ENTRY_rowspan: mergeEntry ? mergeEntry.ENTRY_subPid.length + 1 : null,
          EXIT_groups: mergeExit ? mergeExit.EXIT_group : null,
          EXIT_rowspan: mergeExit ? mergeExit.EXIT_subPid.length + 1 : null,
        });
      });
      // console.log(modelList);
      rowList.map(objRow => ({ ...dataModel, ...objRow }));
      let totalRow = modelList.reduce(function (accumulator, item) {
        accumulator["SUPPLY_PLAN_ENTRY"] =
          (accumulator["SUPPLY_PLAN_ENTRY"] || 0) + item["SUPPLY_PLAN_ENTRY"];
        accumulator["SUPPLY_ACTUAL_ENTRY"] =
          (accumulator["SUPPLY_ACTUAL_ENTRY"] || 0) +
          item["SUPPLY_ACTUAL_ENTRY"];
        accumulator["DEMAND_PLAN_EXIT"] =
          (accumulator["DEMAND_PLAN_EXIT"] || 0) + item["DEMAND_PLAN_EXIT"];
        accumulator["DEMAND_ACTUAL_EXIT"] =
          (accumulator["DEMAND_ACTUAL_EXIT"] || 0) + item["DEMAND_ACTUAL_EXIT"];
        return { ...dataModel, ...accumulator, SUPPLYDEMAND_NAME: "Total" };
      }, {});

      let entryReduce = mergeEntryCell.reduce(
        (total, item) => {
          let temp = dataListMerge.dtEntry.find(
            row => item.ENTRY_subPid.indexOf(row.SUPPLYENTRY_PID) >= 0
          );
          if (temp) {
            total.SUPPLY_PLAN_ENTRY =
              total.SUPPLY_PLAN_ENTRY + temp.SUPPLY_PLAN_ENTRY;
            total.SUPPLY_ACTUAL_ENTRY =
              total.SUPPLY_ACTUAL_ENTRY + temp.SUPPLY_ACTUAL_ENTRY;
          }
          return { ...total };
        },
        { SUPPLY_PLAN_ENTRY: 0, SUPPLY_ACTUAL_ENTRY: 0 }
      );
      let exitReduce = mergeExitCell.reduce(
        (total, item) => {
          let temp = dataListMerge.dtExit.find(
            row => item.EXIT_subPid.indexOf(row.DEMANDEXIT_PID) >= 0
          );
          if (temp) {
            total.DEMAND_PLAN_EXIT =
              total.DEMAND_PLAN_EXIT + temp.DEMAND_PLAN_EXIT;
            total.DEMAND_ACTUAL_EXIT =
              total.DEMAND_ACTUAL_EXIT + temp.DEMAND_ACTUAL_EXIT;
          }
          return { ...total };
        },
        { DEMAND_PLAN_EXIT: 0, DEMAND_ACTUAL_EXIT: 0 }
      );
      totalRow.SUPPLY_PLAN_ENTRY =
        totalRow.SUPPLY_PLAN_ENTRY - entryReduce.SUPPLY_PLAN_ENTRY;

      totalRow.SUPPLY_ACTUAL_ENTRY =
        totalRow.SUPPLY_ACTUAL_ENTRY - entryReduce.SUPPLY_ACTUAL_ENTRY;

      totalRow.DEMAND_PLAN_EXIT =
        totalRow.DEMAND_PLAN_EXIT - exitReduce.DEMAND_PLAN_EXIT;

      totalRow.DEMAND_ACTUAL_EXIT =
        totalRow.DEMAND_ACTUAL_EXIT - exitReduce.DEMAND_ACTUAL_EXIT;
      // console.log(totalRow)
      // console.log(totalRow.SUPPLY_PLAN_ENTR,)
      totalRow.SUPPLY_DIFF_ENTRY = `${totalRow.SUPPLY_PLAN_ENTRY != totalRow.SUPPLY_ACTUAL_ENTRY
        ? totalRow.SUPPLY_PLAN_ENTRY > totalRow.SUPPLY_ACTUAL_ENTRY
          ? "-"
          : "+"
        : ""
        } ${Math.abs(totalRow.SUPPLY_PLAN_ENTRY - totalRow.SUPPLY_ACTUAL_ENTRY)
        }`;
      totalRow.DEMAND_DIFF_EXIT = `${totalRow.DEMAND_PLAN_EXIT != totalRow.DEMAND_ACTUAL_EXIT
        ? totalRow.DEMAND_PLAN_EXIT > totalRow.DEMAND_ACTUAL_EXIT
          ? "-"
          : "+"
        : ""
        } ${Math.abs(totalRow.DEMAND_PLAN_EXIT - totalRow.DEMAND_ACTUAL_EXIT)
        }`;
      return [...modelList, totalRow];
    }
  };
  const openDialogFormula = () => {
    setShowDialogFormula(true);
  }

  return (
    <div>
      <Row className="mt-0">
        <Col sm="12">
          <h5 className="mb-0 sm-0 font-size-18" style={{ color: "#46FCFF" }}>
            {" "}
            System Entry & Exit Summary
          </h5>
        </Col>
      </Row>

      <Row className="mt-2">
        <hr style={{ color: "#46FCFF" }} />
      </Row>
      {permission.mMIM && (
        <>
          <Row className="mt-0">
            <Col sm="6" className="d-flex align-items-center justify-content-start">
              <div className="d-grid gap-2 d-md-block">


                <Button
                  onClick={() => handleShowManageEntryColumn()}
                  color="primary"
                  className="btn w-md ms-0"
                // disabled={readonly == true}
                >
                  <i className="bx bx-columns"> </i> &nbsp;&nbsp;&nbsp; Manage Plan
                  Entry &nbsp;&nbsp;&nbsp;
                </Button>
                <Button
                  onClick={() => handleShowManageExitColumn()}
                  color="primary"
                  className="btn w-md ms-2"
                // disabled={readonly == true}
                >
                  <i className="bx bx-columns"> </i> &nbsp;&nbsp;&nbsp; Manage Plan
                  Exit &nbsp;&nbsp;&nbsp;
                </Button>
              </div>
            </Col>
          </Row>
        </>
      )}

      <Row className="mt-2">
        <Col sm="6" className="d-flex align-items-center justify-content-start">
          <h5 className="mb-0 sm-0 font-size-15 " style={{ color: "#46FCFF" }}>

            Summary Date :
            {
              moment(props.date).locale("en").format("D MMM YYYY")
              // .add(543, "year")
              // .locale("th")
            }
          </h5>
        </Col>
        <Col sm="4" className="d-flex align-items-center justify-content-end">
          <h5 className="mb-0 sm-0 font-size-15" style={{ color: "#46FCFF" }}>
            {" "}
            Unit : MMscfd
          </h5>
        </Col>
      </Row>

      <Row className="mt-1">
        <Col lg="10">
          <div>
            <BootstrapTable
              id="suply-demand-table"
              wrapperClasses="table-on-scroll"
              keyField="SUPPLYDEMAND_NAME"
              data={modelDeviceList}
              columns={columnsSummary}
              rowStyle={rowStyleSummary}
              // rowClasses={rowClass}
              headerClasses="header-style"
            />
          </div>

        </Col>
        <Col lg="2">
          <div className="table-responsive">
            {/* hover-table-highlight */}
            <Table className="table table-bordered mb-0">
              <thead>
                <tr>
                  <th
                    style={{
                      backgroundColor: "#556ee64a",
                      color: "#46FCFF",
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    Unit
                  </th>
                  <th
                    style={{
                      backgroundColor: "#556ee64a",
                      color: "#46FCFF",
                      textAlign: "center",
                      width: "10%",
                    }}
                  >
                    Bypass Gas
                  </th>
                </tr>
              </thead>
              <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                <tr>
                  {/* <td>{byPassGas.BYPASS_UNIT}</td> */}
                  <td>MMscfd</td>
                  <td>{verSion2NumberFormat(byPassGas.BYPASSGAS_VOLUME, 2)}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>

      <Modal size="xl" isOpen={showManageEntryColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Plan Entry</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageEntryColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-supply-demand-table"
            keyField="ROW"
            data={columnEntryManageList}
            columns={columnEntryManage}
            rowStyle={rowStyleFontWhite}
            wrapperClasses="table-on-scroll"
            headerClasses="header-style"
            defaultSorted={defaultEntrySortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(entryDataList);
              },
            })}
          />
          <div className="modal-footer">

            {/* {permission.mMIM && (
              <> */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddEntryColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveEntryColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            {/* </>
            )} */}

            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageEntryColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>

      <Modal size="xl" isOpen={showManageExitColumn} backdrop={"static"} style={{ maxWidth: "90%" }}>
        <div className="modal-header" >
          <h5 className="modal-title mt-0">Manage Plan Exit
            <i className="fas fa-info-circle mt-1 mb-3 ms-3" id="calFormula" style={{ cursor: "pointer", fontSize: "20px", color: "#0080FF" }} onClick={() => openDialogFormula()}>
              <UncontrolledTooltip
                placement="bottom-start"
                target="calFormula"
                style={{ maxWidth: "300px" }}
              >
                <span style={{ fontSize: "15px" }}>
                  Click to see the calculation formula.
                </span>
              </UncontrolledTooltip>
            </i>
          </h5>


          <button
            type="button"
            onClick={() => {
              setShowManageExitColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div>
          </div>
          <div className="table-responsive">
            <BootstrapTable
              id="collumn-supply-demand-table"
              keyField="ROW"
              data={columnExitManageList}

              columns={columnExitManage}
              rowStyle={rowStyleFontWhite}
              wrapperClasses="table-on-scroll width-table"
              headerClasses="header-style"
              defaultSorted={defaultExitSortColumnManage}
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                afterSaveCell: (oldValue, newValue, row, column) => {

                },
              })}
            />
          </div>

          <div className="modal-footer">
            {/* {permission.mMIM && (
              <> */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddExitColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveExitColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            {/* </>
            )} */}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageExitColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>

      <Modal size="xl" isOpen={showManageEntryColumn} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Manage Plan Entry</h5>

          <button
            type="button"
            onClick={() => {
              setShowManageEntryColumn(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <BootstrapTable
            id="collumn-supply-demand-table"
            keyField="ROW"
            data={columnEntryManageList}
            columns={columnEntryManage}
            rowStyle={rowStyleFontWhite}
            wrapperClasses="table-on-scroll"
            headerClasses="header-style"
            defaultSorted={defaultEntrySortColumnManage}
            cellEdit={cellEditFactory({
              mode: "click",
              blurToSave: true,
              afterSaveCell: (oldValue, newValue, row, column) => {
                // console.log(entryDataList);
              },
            })}
          />
          <div className="modal-footer">
            {/* {permission.mMIM && (
              <> */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => handleAddEntryColumn()}
            >
              <i className="bx bx-plus"></i>&nbsp; Add
            </button>

            <button
              type="button"
              className="btn btn-success"
              onClick={() => handleSaveEntryColumn()}
            >
              <i className="bx bx-save"></i>&nbsp; Save
            </button>
            {/* </>
            )} */}
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowManageEntryColumn(false)}
            >
              Close
            </button>
          </div>
        </div>
      </Modal>

      <Modal size="xl" isOpen={showDialogFormula} backdrop={"static"}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">Calculation Formula</h5>

          <button
            type="button"
            onClick={() => {
              setShowDialogFormula(false);
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="media align-items-center mt-2">
            <img
              src={img1}
              alt=""
              style={{ maxWidth: "5000px" }}
              className="img-thumbnail mx-auto d-block"
            />
          </div>
        </div>
        <div className="modal-footer">
          <span style={{ color: "#FF5656", fontSize: "14px" }}>*** สำหรับใน Zone East + Use โรงแยก [CUSTOMERTYPE=GSP & Point = Exit] -  [CUSTOMERTYPE=GSP & Point = Extry] *** </span>
        </div>
      </Modal>
    </div>
  );
}

SupplyDemand.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SupplyDemand;
